import {useState, useEffect, useRef} from "react";
import { Chart as ChartJS, ArcElement, Legend, Tooltip, Title, Filler } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { getgraphicsprinc, getparamsgraphics } from "../../../services/graphics";
import CardService from "./cardservice1";
import { ErrorContext } from "../../../utils/context/error";
import AreaModal from "./areamodal";
import CardInfo from "./cardinfo";
import ResumenAtenciones from "./resumenatenciones";
import Icon from "../../../Icons/general/Icon";


function GraphicPrincView() {
   const [AreaFId, setAreaFId] = useState(0);
   const [CantTurnos, setCantTurnos] = useState(0);
   const [Turnos, setTurnos] = useState([]);
   const [servicio, setServicio] = useState([]);
   const [datos, setDatos] = useState([]);
   const [isOpen, setisOpen]= useState(false);
   const { setShowToast, setOpciones } = ErrorContext();
   
   let TotalTurnos = useRef(0);
   let NombreArea = useRef("");
   let NombreEstado = useRef([]);
   let Color = useRef([]);
   let FillColor = useRef([]);
   let Procesos = useRef(0);
   ChartJS.register(ArcElement, Tooltip, Legend, Title, Filler);

 //---------------------------------------------------------------------------------------------------------------------
  const realizarConsulta =(AreaId) =>
  {
   if (AreaId ===0)
    fillInicioGrafica()
  else  
    fillGrafica(AreaId);
  }
 
//---------------------------------------------------------------------------------------------------------------------
  const fillInicioGrafica = async() => 
    {
      const response = await getparamsgraphics();
      if (response) 
        {
          if (response.status === 200) 
            {
              setAreaFId(response.data.area[0].AreaId);
              realizarConsulta(response.data.area[0].AreaId);
            }
          else
          {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
          }
        }
    }

//----------------------------------------------------------------------------------------------------------------------
  const fillGrafica = async (AreaId) => {
    if (AreaId >0)
    {
       const response = await getgraphicsprinc(AreaId);
       if (response) 
        {
           if (response.status === 200) 
            {
               CargarDatos(response.data.data[0]);
               setDatos(response.data.data[0]);
               NombreArea.current = response.data.area[0].NombreArea; 
               setAreaFId(response.data.area[0].AreaId);
               setServicio(response.data.servicio);
            }
           else
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
        }
        else
           {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
           }
    }       
  };

//----------------------------------------------------------------------------------------------------------------------
 const CargarDatos = (resultados) => 
  {
     if (!resultados) 
      {
        setTurnos([]);
        setCantTurnos(0);
        return;
      }

     const {Consecutivo = 0, Atendido = 0, PorAtender = 0, Pendientes = 0,} = resultados;
     const EnProceso = Math.max(0, Consecutivo - Atendido - PorAtender - Pendientes);

     Procesos.current = EnProceso;
     TotalTurnos.current = Consecutivo;

     // Etiquetas
     NombreEstado.current = ["Atendidos", "Por atender", "Pendientes", "En proceso"];
     // Colores
     Color.current = [
       "#16BDCA", // Atendido
       "#FDBA8C", // Por atender
       "#1C64F2", // Pendiente
       "#E74694", // En proceso
     ];
     // Datos
     setTurnos([Atendido, PorAtender, Pendientes, EnProceso,]);
     setCantTurnos(Consecutivo);
  };

//----------------------------------------------------------------------------------------------------------------------
const data = 
{
  labels: NombreEstado.current,
  datasets: [
    {
      data: Turnos,
      backgroundColor: Color.current,
      borderWidth: 0,
      spacing: 4,
      borderRadius: 8,
      hoverOffset: 6,
    },
  ],
};

//----------------------------------------------------------------------------------------------------------------------
const options = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "72%",

  animation: {animateRotate: true, duration: 700,},
  plugins: {
    legend: {
      display: false,
    },

    tooltip: {
      enabled: true,
    },
  },
};

//----------------------------------------------------------------------------------------------------------------------
const emptyDoughnut = 
{
  id: "emptyDoughnut",

  afterDraw(chart) 
  {
    const dataset = chart.data.datasets?.[0];
    const valores = dataset?.data ?? [];

    const estaVacio =
      valores.length === 0 ||
      valores.every((valor) => Number(valor) === 0);

    if (!estaVacio) return;

    const {
      ctx,
      chartArea: { left, top, right, bottom },
    } = chart;

    const centerX = (left + right) / 2;
    const centerY = (top + bottom) / 2;

    const radio =
      Math.min(right - left, bottom - top) / 2 - 12;

    const grosor = 18;
    const separacion = 0.035;
    const colores = [
      "#E2E8F0",
      "#CBD5E1",
      "#E2E8F0",
      "#CBD5E1",
    ];

    ctx.save();
    ctx.lineWidth = grosor;
    ctx.lineCap = "round";

    for (let i = 0; i < 4; i += 1) {
      const inicio =
        -Math.PI / 2 +
        i * (Math.PI / 2) +
        separacion;

      const fin =
        -Math.PI / 2 +
        (i + 1) * (Math.PI / 2) -
        separacion;

      ctx.beginPath();
      ctx.strokeStyle = colores[i];
      ctx.arc(centerX, centerY, radio, inicio, fin);
      ctx.stroke();
    }

    ctx.fillStyle = "#94A3B8";
    ctx.font = "600 16px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("Sin datos", centerX, centerY);

    ctx.restore();
  },
}; 
 //---------------------------------------------------------------------------------------------------------------------
  useEffect(() => {
    fillInicioGrafica();
  },[]);

//----------------------------------------------------------------------------------------------------------------------
 const plugins = [emptyDoughnut];
   return (
    <>
      <div className="min-h-screen bg-slate-100">
        <div className="mx-auto w-full max-w-[90rem] px-3 py-4 sm:px-4 md:px-5 lg:px-6 xl:px-8 2xl:px-10">
            <div className="space-y-5 lg:space-y-6">
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4 xl:gap-5">
                <CardInfo icon={<Icon svg="usercheck" className="fill-current text-atendido"/>}   title="Atendidos"    value={datos?.Atendido ?? 0}   color="text-atendido"    bgColor="bg-atendido/10" />
                <CardInfo icon={<Icon svg="userclock" className="fill-current text-poratender"/>} title="Por Atender"  value={datos?.PorAtender ?? 0} color="text-poratender"  bgColor="bg-poratender/15" />
                <CardInfo icon={<Icon svg="userslash" className="fill-current text-pendiente"/>}  title="Pendientes"   value={datos?.Pendientes ?? 0} color="text-pendiente"   bgColor="bg-pendiente/10"  />
                <CardInfo icon={<Icon svg="usersline" className="fill-current text-enproceso"/>}  title="En Proceso"   value={Procesos.current ?? 0}  color="text-enproceso"   bgColor="bg-enproceso/10" />
              </div>

                {/* Resumen */}
              <ResumenAtenciones  CantTurnos={CantTurnos} datos={datos} Procesos={Procesos} data={data} options={options} plugins={plugins}/>
                {/* Servicios */}
              <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-[0_10px_28px_rgba(15,23,42,0.10) sm:p-5 lg:p-6">
                <div className="mb-5 flex items-center justify-between">
                  <div>
                      <h2 className="text-xl font-semibold text-slate-700">
                        Detalle de servicios
                      </h2>
                      <p className="mt-1 text-sm text-slate-400">
                        Estado actual por servicio
                      </p>
                  </div>
                </div>

                {servicio.length > 0 ? (
                  <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
                      {servicio.map((item) => (
                        <CardService key={`${item.AreaId}-${item.ServicioId}`} prefijo={item.Prefijo} icon={item.Icon} nombre={item.NombreServ} area={item.AreaId}
                                     atendidos={item.TurnoAten} porAtender={item.TurnoRes} pendientes={item.TurnoPend} enProceso={Math.max(0,(Number(item.Consecutivo) || 0) - (Number(item.TurnoAten) || 0) - (Number(item.TurnoRes) || 0) - (Number(item.TurnoPend) || 0))}
                        />
                      ))}
                  </div>
                ) : 
                (
                  <div className="flex min-h-[14rem] flex-col items-center justify-center">
                    <div className="h-12 w-12 text-slate-300 fill-slate-300">
                        <Icon svg="information" />
                    </div>

                    <p className="mt-4 text-sm text-slate-400">
                        No hay servicios en producción
                    </p>
                  </div>
                )}
            </section>
          </div>
      </div>
  </div>
    </>
     );
  }

  
  export default GraphicPrincView;
  